/** @jsx jsx */
import { jsx } from 'theme-ui';
import { jsx as ___EmotionJSX } from "@emotion/core";
export const Pre = ({
  children
}) => jsx("div", null, children);

if (typeof Pre !== 'undefined' && Pre && Pre === Object(Pre) && Object.isExtensible(Pre) && !Pre.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Pre, '__filemeta', {
    configurable: true,
    value: {
      name: "Pre",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Pre/index.js"
    }
  });
}